// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2975) return "static/chunks/2975-1615e5ca8be66165.js";
	if (chunkId === 9139) return "static/chunks/9139-17dd3644d65b10b4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4284":"ba1712fc","9486":"cdcd3b9e"}[chunkId] || chunkId) + "." + {"4284":"c466ca9d52619002","4841":"9b8b6b697c8e0c5a","7182":"66e0a7aa08602b7b","7222":"9b8b6b697c8e0c5a","8950":"bb6d760ee2f69959","9486":"9fdb4a526be12d00"}[chunkId] + ".js";
};